import React, {useState} from "react";
import { Row, Col, Button } from "reactstrap";

const FixedCostsHints = () => {

  const [showHints,setShowHints] = useState(false);

  return(
    <Col xs={12} className="fixed-costs-hints responsive-fontsize">

      <Row>
        <Col className="d-flex align-items-center justify-content-start" style={{padding:'0px'}}>
          <Button 
            className="button shadow-none responsive-fontsize"
            onClick={()=>setShowHints(!showHints)}
          >
            {showHints ? 'Dölj' : 'Visa'} exempel
          </Button>
        </Col>

      </Row>

      {showHints ? 
        (
          <ul className="ms-2 mt-4">
            <li className="hint"> Löner </li>
            <li className="hint"> Produktions-omkostnader </li>
            <li className="hint"> Marknadsföring och säljkostnader </li>
            <li className="hint"> Egen utbildning </li>
            <li className="hint"> Lokaler </li>
            <li className="hint"> Internet, mobil, etc </li>
            <li className="hint"> Försäkringar </li>
            <li className="hint"> Redovisning och revision </li>
            <li className="hint"> Administration och övrigt </li>
            <li className="hint"> Bankkostnader/räntenetto </li>
            <li className="hint"> Avskrivningar </li>
            <li className="hint"> Diverse </li>
          </ul>
        ) 
        :''
      }
      
    </Col>
  );

}
export default FixedCostsHints;